<template>
    <transition name="move">
        <div id="reg" ref="regdom">
            <!-- <img class="login-bg" src="../../assets/login_bg.png" alt=""> -->
            <div class="content">
                <div class="inner">
                    <div class="login-bg"></div>
                    <div class="login-form">
                        <div class="mark-box"><img src="../../assets/agent_mark_icon.png" alt=""></div>
                        <div class="border-bottom-right"></div>
                        <div class="login-title"><img src="../../assets/logo.1.png" alt=""></div>
                        <el-form :model="regForm" ref="regForm" label-width="100px" class="demo-ruleForm">
                            <el-form-item
                                label="用户姓名"
                                prop="username"
                                :rules="[
                                { required: true, message: '请输入您的真实姓名'}
                                ]"
                            >
                                <el-input type="text" v-model="regForm.username" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item
                                label="用户账号"
                                prop="account"
                                :rules="[
                                { required: true, message: '请输入您的手机号码'},
                                { type: 'number', message: '请输入您的手机号码'}
                                ]"
                            >
                                <el-input type="number" v-model.number="regForm.account" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item 
                                label="用户密码" 
                                prop="pass"
                                :rules="[
                                { required: true,message: '请输入密码'}
                                ]"
                            >
                                <el-input type="password" v-model="regForm.pass" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item 
                                label="确认密码" 
                                prop="checkpass"
                                :rules="[
                                { required: true,message: '请输入确认密码'}
                                ]"
                            >
                                <el-input type="password" v-model="regForm.checkpass" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="所在地区" :rules="[{required: true}]">
                                <el-cascader
                                    :options="regForm.options"
                                    v-model="regForm.selectedOptions"
                                    @change="selectArea">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="reg()">注册</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="showLogin()">登录</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="footer">易卡多e-card官方客服电话:0512-65359917</div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Reg',
  data () {
    return {
        fullscreenLoading: false,
        regForm: {
            username: '',
            account: '',
            pass: '',
            checkpass: '',
            options: [],
            selectedOptions: [],
            citycode: ''
        }
    }
  },
  created() {
      this.getArea();
  },
  methods: {
    selectArea(value) {
        this.regForm.citycode = value[1];
    },
    getArea() {
        var _this = this;
        this.$http({
            method: 'get',
            url: _this.$api + '/service/agent/all_area'
        }).then((res) => {
            this.regForm.options = res.data.data;
            this.regForm.options.forEach((element) => {
                element.children.forEach((item) => {
                    delete item.children;
                });
            });
        });
    },
  	reg() {
        this.fullscreenLoading = true;
   		let params = new URLSearchParams();
        var _this = this;
        let regForm = _this.regForm;
  		params.append("username",regForm.username);
  		params.append("account",regForm.account);
  		params.append("password",regForm.pass);
  		params.append("confirm_password",regForm.checkpass);
  		params.append("citycode",regForm.citycode);
  		this.$http({
  			method: 'post',
  			url: _this.$api + '/service/agent/register',
  			data: params
  		}).then(function(res){
            _this.fullscreenLoading = false;
  			if(res.data.code == 200) {
                _this.toast(res.data.data,'success');
                _this.$emit('listenChilder');
  			} else {
                _this.toast(res.data.data,'warning');
  			}
  		})
    },
    toast(message,type) {
        this.$message({
          message: message,
          type: type
        })
    },
    showLogin() {
        this.$router.push('/Login')
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">	
    #reg
        position: fixed 
        top: 0
        left: 0
        bottom: 0
        right: 0
        background: #fff
        z-index: 30
        &.move-enter-active,&.move-leave-active
            transition: all .2s linear 
        &.move-enter,&.move-leave-active
            transform: translate3d(0,-100%,0)
        .login-bg
            position: absolute
            width: 100%
            height: 100%
        .content
            width: 100%
            height: 100%
            background: url(../../assets/login_big_bg.png) no-repeat center 0
            background-size: cover
            padding-top: 30px
            padding-bottom: 100px
            .inner
                position: relative
                widdth: 966px
                height: 750px
                margin: 0 auto
                .login-bg
                    position: absolute
                    width: 949px
                    height: 598px
                    background: url(../../assets/login_bg.png) no-repeat center 6px
                    left: -100px
                .login-form
                    position: absolute 
                    width: 420px
                    min-height: 420px
                    background: #fff
                    padding: 0 45px 110px
                    right: 25px
                    top: 0
                    box-shadow: 0px 2px 98px 0px rgba(227, 214, 214, 0.5)
                    border-radius: 20px
                    border-bottom-right-radius: 170px
                    .border-bottom-right
                       position: absolute 
                       width: 158px
                       height: 192px
                       pointer-events: none
                       right: 0
                       bottom: -1px
                       background: url(../../assets/login_form_img.png) no-repeat 6px
                    .mark-box
                        position: absolute 
                        right: -3px
                        top: -3px
                        img 
                            vertical-align: middle
                    .login-title
                       margin-top: 70px
                       height: 81px
                       line-height: 81px
                       color: #333
                       text-align: center 
                       font-size: 28px
                       img 
                            vertical-align: middle
                    .el-button
                        padding: 12px 145px
        .footer
            position: absolute
            width: 100%
            left: 0
            bottom: 30px
            text-align: center 
            font-size: 16px
</style>


// WEBPACK FOOTER //
// src/components/reg/reg2.vue